import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { Stack } from '@src/components';
import { DateField } from '@src/corelib/forms/generic';
import 'dayjs/locale/de';


function FromField(props) {
  return <DateField fullWidth label="From" name="date_from" {...props} />;
}
function ToField(props) {
  return <DateField fullWidth label="To" name="date_to" {...props} />;
}

export function DatesRangeField({hoursView}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
      <Stack spacing={2} direction="row">
        <FromField label={hoursView ? 'Date' : 'From'} />
        {!hoursView && <ToField />}
      </Stack>
    </LocalizationProvider>
  );
}

